import React from "react";
import style from "./index.module.scss";
import classNames from "classnames";

interface StaticsProps {
    committed: number;
    uncommitted: number;
    current: string;
    onChange: (select: string) => void;
}

export default function Statics({
    committed,
    uncommitted,
    current,
    onChange
}: StaticsProps) {
    return (
        <div className={style.root}>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "all"
                })}
                onClick={() => onChange("all")}>
                <em>{committed + uncommitted}</em>课程人数
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "committed"
                })}
                onClick={() => onChange("committed")}>
                <em>{committed}</em>已参与
            </div>
            <div
                className={classNames(style.statics, {
                    [style.active]: current === "uncommitted"
                })}
                onClick={() => onChange("uncommitted")}>
                <em>{uncommitted}</em>未参与
            </div>
        </div>
    );
}
